import {api} from './requestGraphql.js'

const getPayments = async (data) => {
  try {
    const sort = `{sortBy: "${data.orderBy || 'date_added'}", sortAsk: ${data.orderBy ? data.orderDirectionAsc : false}}`;
    const pagination = `{page: ${data.page},limit: ${data.limit}}`;
    let preparedFilters = ''

    for (const filter in data.filters) {
      preparedFilters += (!!data.filters[filter]) ?
        Array.isArray(data.filters[filter]) ? `${filter}: ["${data.filters[filter].join('","')}"]` : `${filter}: "${data.filters[filter]}"` :  ''
    }
    const res = await api.post(
      '', {
        query: `{
          payments(input:{sort:${sort}, pagination: ${pagination}, filters: {${preparedFilters}}}) {
            data {
              id
              status
              billing_cycle
              referral_commission
              carry_over_referral_commission
              amount
              affiliate_id
              affiliate_status
              affiliate_manager_id
              affiliate_manager_name
              start_period
              end_period
              affiliateName
              paymentType
              paymentTypeId
              currencySymbol
              isPaymentMethodIsTipalti
              currencyName
              paymentTerm
              total
              balance
              paid
              affiliate {
                paymentMethodId
                paymentType
                email
                affiliate_information {
                  street_address
                  street_address_2
                  city
                  state
                  postal_code
                  country
                  company_name
                  company_address
                  vat_number
                }
              }
              payment_items {
                id
                geo
                offer_id
                campaign_id
                item_name
                amount
                offer_currency_id
                count
                currency_rate
                payment_currency
                item_currency
              }
              history {
                entity
                action
                field_name
                from_value
                to_value
                initiator
                date_added
              }
            }
            count
          }
        }`,
      }
    );

    let response = res.data.data.payments;
    console.log(` *** getLogs from DB response count:${response.length}`);
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const getPaymentsCalculations = async (data) => {
  try {
    let preparedFilters = ''

    for (const filter in data.filters) {
      preparedFilters += (!!data.filters[filter]) ?
        Array.isArray(data.filters[filter]) ? `${filter}: ["${data.filters[filter].join('","')}"]` : `${filter}: "${data.filters[filter]}"` :  ''
    }

    const res = await api.post(
      '', {
        query: `
          {
            paymentsCalculations(input:{filters: {${preparedFilters}}}) {
              data {
                paymentAmount
                paymentType
                details {
                  id
                  email
                  amount
                  referralCommission
                  payoneerUsername
                  payoneerEmail
                  bitcoinWallet
                  paymentDate
                  paymentType
                  paymentId
                  description
                  groupId
                  carriedOverReferralCommission
                  abbr
                  scheduledDate
                  refCode
                  eWalletMessage
                  bankingMessage
                  ignoreThresholds
                  visibleWhenScheduled
                  emailMessage
                  transactionDescription
                }
              }
              total
            }
          }
         `,
      }
    );

    let response = res.data.data.paymentsCalculations;
    response.data.forEach((details) => {
      details.details.forEach((item) => {
        item.ignoreThresholds = Number(item.ignoreThresholds) ? 'TRUE' : 'FALSE';
        item.visibleWhenScheduled = Number(item.visibleWhenScheduled) ? 'TRUE' : 'FALSE';
      });
    });

    console.log(` *** paymentsCalculations from DB response count:${response.data.length}`);

    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const updatePayment = async (data) => {
  try {
    if (!data.paymentId || !data.action) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `mutation {
          updatePayment (paymentId: ${data.paymentId}, action: "${data.action}") {
            id
          }
        }`,
      }
    );

    let response = res.data.data.updatePayment;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const massUpdatePayments = async (data) => {
  try {
    if (!data.paymentIds || !data.action) {
      throw new Error('Wrong params');
    }
    const ids = data.paymentIds.map( id => parseInt(id));
    const res = await api.post(
      '', {
        query: `mutation {
          updatePayments (paymentIds: [${ids}], action: "${data.action}")
        }`,
      }
    );

    let response = res.data.data.updatePayments;
    return response
  } catch (error) {
    console.error(error)
    throw new Error(error);
  }
}

const partialPayPayments = async (payments) => {
  try {
    if (!Array.isArray(payments) || payments.length === 0) {
      throw new Error('No partial payments provided');
    }

    const inputString = payments.map(p => `{ id: ${p.id}, payAmount: ${p.payAmount} }`).join(', ');

    const res = await api.post('', {
      query: `
        mutation {
          partialPayPayments(payments: [${inputString}])
        }
      `,
    });

    return res.data.data.partialPayPayments;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

const getPaymentItems = async (data) => {
  try {
    if (!data.paymentId) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `query {
          paymentItems(payment_id: ${data.paymentId}) {
            id
            itemName
            geo
            campaignId
            count
            itemCurrency
            amount
            currencyRate
            sumAmount
          }
        }`,
      }
    );

    let response = res.data.data.paymentItems;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const getPaymentDetails = async (data) => {
  try {
    if (!data.paymentId) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `query {
          paymentDetails(payment_id: ${data.paymentId}) {
            field
            value
          }
        }`,
      }
    );

    let response = res.data.data.paymentDetails;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const getFilter = async (data) => {
  let preparedFilters = ''
  for (const filter in data.filter) {
    preparedFilters += (!!data.filter[filter]) ?
      Array.isArray(data.filter[filter]) ? `${filter}: ["${data.filter[filter].join('","')}"]` : `${filter}: "${data.filter[filter]}"` :  ''
  }

  const result = await api.post('', {
      query: `
          {
            paymentFiltersData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", filter: {${preparedFilters}}) {
              key,
              value
            }
          }
        `
    },
  )

  if(result.status === 200) {
    const prettyData = [];
    if(result.data.data.paymentFiltersData) {
      for(let i = 0; i < result.data.data.paymentFiltersData.length; i++) {
        prettyData.push(result.data.data.paymentFiltersData[i]);
      }
      return prettyData;
    }
  }
}

const addNote = async (data) => {
  try {
    if (!data.paymentId || !data.note) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `mutation {
          addNote (paymentId: ${data.paymentId}, note: """${data.note}""")
        }`,
      }
    );

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    let response = res.data.data.addNote;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const addPaymentModification = async (data) => {
  try {
    if (!data.paymentId || !data.note || !data.amount) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `mutation {
          addPaymentModification (paymentId: ${data.paymentId}, note: """${data.note}""", amount: ${data.amount})
        }`,
      }
    );

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    let response = res.data.data.addPaymentModification;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const getNotes = async (data) => {
  try {
    if (!data.paymentId) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `query {
          notes (paymentId: ${data.paymentId}) {
            id
            note
            date_added
            author_email
            payment_modification {
              amount
              item_currency
            }
          }
        }`,
      }
    );

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    let response = res.data.data.notes;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const getPaymentModifications = async (data) => {
  try {
    if (!data.paymentId) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `query {
          paymentModifications (paymentId: ${data.paymentId}) {
            id
            item_currency
            amount
            note
            currency_rate
          }
        }`,
      }
    );

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    let response = res.data.data.paymentModifications;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const getPaymentAmount = async data => {
  try {
    if (!data.paymentId) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `query {
          paymentAmount(payment_id: ${data.paymentId}) {
            amountDetails{
              id
              sales
              modifications
              carryOverAmount
              referralCommission
              carryOverReferralCommission
              currentPeriod
              previousPeriod
            }
          }
        }`,
      }
    );

    let response = res.data.data.paymentAmount;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const download = async data => {
  try {
    if (!data || !data.length) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
      '', {
        query: `query {
          download(payment_ids:[${data}]){
            files{
              content
              payment_id
            }
          }
        }`,
      }
    );

    return res.data.data.download;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const uploadCSVData = async data => {
  const rows = JSON.stringify(data.rows).replace(/"/g, '\\"');
  const method = data.method;
  try {
    if (!rows || !rows.length || !method) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
        '', {
          query: `mutation {
            uploadCSVData (rows: "${rows}", method: "${method}") 
        }`,
        }
    );
    let response = res.data.data.uploadCSVData;
    return response
  } catch (error) {
    console.error(error)
    throw new Error(error);
  }
}

const getMethods = async (data) => {
  try {
    const sort = `{sortBy: "${data.orderBy || 'name'}", sortAsk: ${data.orderBy ? data.orderDirectionAsc : false}}`;
    const pagination = `{page: ${data.page},limit: ${data.limit}}`;
    let preparedFilters = ''
    
    for (const filter in data.filters) {
       preparedFilters += (!!data.filters[filter]) ?
           Array.isArray(data.filters[filter]) ? `${filter}: ["${data.filters[filter].join('","')}"]` : `${filter}: "${data.filters[filter]}"` :  ''
    }
    const res = await api.post(
        '', {
          query: `{
          methods(input:{sort:${sort}, pagination: ${pagination}, filters: {${preparedFilters}}}) {
            data {
              id
              name
              status
              minimum_payment_amount
              tipalti
              is_on_funnel_enabled
              is_on_dashboard_enabled
              banned_geos
            }
            count
          }
        }`,
        }
    );

    let response = res.data.data.methods;
    console.log(` *** getLogs from DB response count:${response.length}`);
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const saveMethod = async (data) => {
  try {
  
    const res = await api.post(
        '', {
          query: `
            mutation {
              saveMethod(input:{name: "${data.name}", 
                                minimum_amount: ${data.minimum_amount}, 
                                tipalti:${data.tipalti},
                                is_on_funnel_enabled:${data.is_on_funnel_enabled},
                                is_on_dashboard_enabled:${data.is_on_dashboard_enabled}
                              }
              ){
                data{
                  name
                  tipalti
                  status
                }
              }
            }
          `,
        }
    );

    return res.data.data.saveMethod;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const updateMethod = async (data) => {
  try {
  
    const res = await api.post(
        '', {
          query: `
            mutation {
              updateMethod(input:{
                id: ${data.id}, 
                name: "${data.name}", 
                minimum_amount: ${data.minimum_amount}, 
                tipalti:${data.tipalti}
                is_on_funnel_enabled:${data.is_on_funnel_enabled},
                is_on_dashboard_enabled:${data.is_on_dashboard_enabled}
              }){
                data{
                  id
                  name
                  minimum_payment_amount
                  tipalti
                  status
                  is_on_funnel_enabled
                  is_on_dashboard_enabled
                }
              }
            }
          `,
        }
    );

    return res.data.data.updateMethod;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const updateMethodBannedGeos = async (data) => {
  try {
    const res = await api.post('', {
      query: `
        mutation UpdateMethodGeos($id: Int!, $geos: String!) {
          updateMethodGeos(id: $id, geos: $geos)
        }
      `,
      variables: {
        id: data.id,
        geos: data.geos
      }
    });

    return res.data.data.updateMethodGeos;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

const getMethodFilter = async (data) => {
  let preparedFilters = ''
  for (const filter in data.filter) {
    preparedFilters += (!!data.filter[filter]) ?
      Array.isArray(data.filter[filter]) ? `${filter}: ["${data.filter[filter].join('","')}"]` : `${filter}: "${data.filter[filter]}"` :  ''
  }

  const result = await api.post('', {
      query: `
          {
            methodFiltersData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", filter: {${preparedFilters}}) {
              key,
              value
            }
          }
        `
    },
  )

  return result.data.data.methodFiltersData
}

const getCountries = async () => {
  try {
    const res = await api.post(
        '', {
          query: `query {
                    countries {
                      code
                      name
                    }
                }`,
        }
    );

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    let response = res.data.data.countries;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const getPaymentHistory = async (data) => {
  try {
    if (!data.paymentId) {
      throw new Error('Wrong params');
    }
    const res = await api.post(
        '', {
          query: `query {
          paymentHistory(payment_id: ${data.paymentId}) {
            to_value
            date_added
            payment_id
          }
        }`,
        }
    );

    let response = res.data.data.paymentHistory;
    return response
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

const exportPayments = async (data) => {
  try {
    if (!data.paymentIds || !Array.isArray(data.paymentIds) || data.paymentIds.length === 0) {
      throw new Error('No payment IDs provided');
    }

    const res = await api.post('', {
      query: `
        query {
          exportPayments(input: { paymentIds: [${data.paymentIds.join(', ')}] }) {
            success
            message
            totalPayments
            csvContent
            filename
          }
        }
      `,
    });

    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }

    return res.data.data.exportPayments;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

export default {
  getPayments,
  getPaymentsCalculations,
  updatePayment,
  getPaymentItems,
  getPaymentDetails,
  getPaymentAmount,
  getFilter,
  massUpdatePayments,
  addNote,
  addPaymentModification,
  getNotes,
  getPaymentModifications,
  download,
  uploadCSVData,
  getMethods,
  saveMethod,
  updateMethod,
  getMethodFilter,
  partialPayPayments,
  getCountries,
  updateMethodBannedGeos,
  getPaymentHistory,
  exportPayments
}
